export default "__VITE_ASSET__d85d4aa0__"